import { FC, useMemo } from 'react';
import { EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import { CounterFormGeneralSettings } from './CounterFormGeneralSettings';
import { CounterFormProformaCounterSettings } from './CounterFormProformaCounterSettings';
import { CounterFormBillCounterSettings } from './CounterFormBillCounterSettings';
import { CounterFormPreviewCounterSettings } from './CounterFormPreviewCounterSettings';

interface CounterFormProps {
    counterType: EnterpriseScopeCounterDiscriminator;
    isEditForm?: boolean;
}

export const CounterForm: FC<CounterFormProps> = ({ counterType, isEditForm }) => {
    const counterTypeSettings = useMemo(() => {
        switch (counterType) {
            case EnterpriseScopeCounterDiscriminator.ProformaCounter:
                return <CounterFormProformaCounterSettings />;
            case EnterpriseScopeCounterDiscriminator.BillPreviewCounter:
                return <CounterFormPreviewCounterSettings />;
            case EnterpriseScopeCounterDiscriminator.BillCounter:
                return <CounterFormBillCounterSettings />;
            default:
                return null;
        }
    }, [counterType]);

    return (
        <Stack vertical spacing="500">
            {counterTypeSettings}
            <CounterFormGeneralSettings type={counterType} isEditForm={isEditForm} />
        </Stack>
    );
};
